<template>
  <div>
    <!-- <section>
      <el-button type="primary" round class="btn-lenguaje" style="float: right; padding: 5px; padding-left: 20px" @click="switchLocale">ES</el-button>
      <el-button type="primary" style="padding: 5px; padding-right: 100px" class="btn-lenguaje" @click="switchLocale">ENG</el-button>
    </section> -->
    <section class="banner">
      <div class="overlay"></div>

      <div class="contenido">
        <div class="idiomas">
          <el-button type="default" class="idioma" @click="switchLocale('es')">ES</el-button>
          <el-button type="default" class="idioma" @click="switchLocale('en')">EN</el-button>
        </div>
        <el-row :gutter="20">
          <el-col :span="24" data-aos="fade-right" data-aos-offset="300"><div class="titulo_principal_css" v-html="$t('header.titulo_trabaja')"></div></el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js'

export default {
  data() {
    return { index: null }
  },
  methods: {
    switchLocale(tipo) {
      // alert('hola')
      // if (this.$i18n.locale === 'es') {
      this.$i18n.locale = tipo
      // } else {
      //   this.$i18n.locale = 'es'
      // }
      EventBus.$emit('change-lenguaje', this.$i18n.locale)
    },
  },
}
</script>
<style>
.banner {
  position: relative;
  background-image: url('~@/assets/fotos/09_HEADER.jpg') !important; /* ruta válida Vue 2 */
  background-size: cover;
  background-position: center;
  height: 250px;
  color: white;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: left;
}

.banner .overlay {
  position: absolute;
  inset: 0;
  /* background: rgba(0, 0, 0, 0.45); */
  background: #00000094;
  z-index: 1;
}

.banner .contenido {
  position: initial;
  z-index: 2;
  /* text-align: center; */
}

/* --- Botones de idioma --- */

.idiomas {
  position: absolute;
  top: 20px;
  right: 30px;
  display: inline-flex;
  background: #fff;
  border-radius: 25px;
  overflow: hidden;
  z-index: 3;
}

.idioma {
  background: transparent;
  border: none;
  color: grey;
  font-weight: 600;
  padding: 6px 14px;
  cursor: pointer;
  transition: 0.3s;
}

/* --- Texto principal --- */
.banner h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 1px;
  margin-top: 2rem;
}
.btn-lenguaje {
  font-weight: 700;
  color: #00000082;
  border: none;
  background-color: white;
}
.w80 {
  width: 80%;
}
.titulo_principal_css {
  /* font-size: 2.5rem; */
  color: #fff;
  font-weight: 300 !important;
  /* margin: 30px; */
  line-height: 1.3;
  /* margin-top: 90px; */
  /* text-align: center; */
  font-family: 'roboto-black';
}
@media (min-width: 2561px) {
  .titulo_principal_css {
    font-size: 65px;
  }
  .banner {
    height: 250px;

    padding: 5% 10% 5% 11%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 1920px) and (max-width: 2560px) {
  .titulo_principal_css {
    font-size: 62px;
  }
  .banner {
    /* height: 400px; */
    padding: 5% 10% 5% 10%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .titulo_principal_css {
    font-size: 56px;
  }
  .banner {
    height: 300px;

    padding: 0px 10%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 1023px) and (max-width: 1439px) {
  .titulo_principal_css {
    font-size: 50px;
  }
  .banner {
    height: 300px;

    padding: 0px 11%;
    /* justify-content: center; */
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .titulo_principal_css {
    font-size: 40px;
  }
  .banner {
    height: 400px;

    padding: 0px 10%;
    /* justify-content: center; */
  }
  .bg-nosotros-trabaja {
    background-color: #d35915;
    position: relative;
    z-index: 999;
    padding: 10% 10% !important;
  }
}
@media screen and (min-width: 375px) and (max-width: 832px) {
  .titulo_principal_css {
    font-size: 40px;
    margin-top: 80px;
  }
  .banner {
    position: relative;
    background-image: url('~@/assets/fotos/09_HEADER.jpg') !important; /* ruta válida Vue 2 */
    background-size: cover;
    background-position: center;
    height: 380px;
    color: white;
    overflow: hidden;
    /* display: flex; */
    /* align-items: center; */
    padding: 0px 5% 0px 10%;
  }
}
@media (max-width: 375px) {
  .titulo_principal_css {
    font-size: 40px;
    margin-top: 80px;
  }
  .banner {
    height: 400px;

    padding: 0px 2% 0px 10%; /* justify-content: center; */
  }
}
</style>
<style scoped>
.fondo-imagen {
  background-image: url('~@/assets/fotos/09_HEADER.jpg') !important;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 300px;
  opacity: 0.7;
  background-color: rgb(0 0 0 / 56%);
  background-blend-mode: overlay;
}
.el-button--warning.is-active,
.el-button--warning:active {
  background: #d35915;
  border-color: #d35915;
  color: #fff;
}
.el-button--warning:active {
  background: #d35915;
  border-color: #d35915;
  color: #fff;
}
.switch {
  position: relative;
  display: inline-block;
  margin: 0 5px;
}

.switch > span {
  position: absolute;
  top: 14px;
  pointer-events: none;
  font-family: 'Helvetica', Arial, sans-serif;
  font-weight: bold;
  font-size: 12px;
  text-transform: uppercase;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  width: 50%;
  text-align: center;
}

input.check-toggle-round-flat:checked ~ .off {
  color: #f36f25;
}

input.check-toggle-round-flat:checked ~ .on {
  color: #fff;
}

.switch > span.on {
  left: 0;
  padding-left: 2px;
  color: #f36f25;
}

.switch > span.off {
  right: 0;
  padding-right: 4px;
  color: #fff;
}

.check-toggle {
  position: absolute;
  margin-left: -9999px;
  visibility: hidden;
}
.check-toggle + label {
  display: block;
  position: relative;
  cursor: pointer;
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

input.check-toggle-round-flat + label {
  padding: 2px;
  width: 97px;
  height: 35px;
  background-color: #f36f25;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  -ms-border-radius: 60px;
  -o-border-radius: 60px;
  border-radius: 60px;
}
input.check-toggle-round-flat + label:before,
input.check-toggle-round-flat + label:after {
  display: block;
  position: absolute;
  content: '';
}

input.check-toggle-round-flat + label:before {
  top: 2px;
  left: 2px;
  bottom: 2px;
  right: 2px;
  background-color: #f36f25;
  /* -webkit- -moz-border-radius: 60px; */
  -ms-border-radius: 60px;
  -o-border-radius: 60px;
  border-radius: 60px;
}
input.check-toggle-round-flat + label:after {
  top: 4px;
  left: 4px;
  bottom: 4px;
  width: 48px;
  background-color: #fff;
  -webkit-border-radius: 52px;
  -moz-border-radius: 52px;
  -ms-border-radius: 52px;
  -o-border-radius: 52px;
  border-radius: 52px;
  -webkit-transition: margin 0.2s;
  -moz-transition: margin 0.2s;
  -o-transition: margin 0.2s;
  transition: margin 0.2s;
}
</style>
